/*
 * Atolyewolf – kardeş ürün (renk/metal) swatch'ları
 * Koleksiyon kartındaki renk noktasına tıklanınca sayfaya gitmek yerine kart yerinde değişir:
 *  1) Görsel anında değiştirilir (data-sibling-image),
 *  2) Ardından Section Rendering API ile ilgili ürünün kartı (/products/<handle>?section_id=aw-product-card)
 *     çekilip başlık, fiyat, hızlı ekle butonu ve bağlantılar dahil kartın içi yenilenir.
 *  3) Yeni kartın swatch listesinde olmayan ama önceki kartta görünen kardeşler korunur
 *     (bir renk sonradan eklenip eski kardeşlerin listesi güncellenmediğinde renk kaybolmasın).
 * Swatch'lar normal bağlantı olarak kalır (JS yoksa ürün sayfasına gider).
 */
(function () {
  if (window.__awSiblingSwatchesReady) return;
  window.__awSiblingSwatchesReady = true;

  var SECTION_ID = 'aw-product-card';

  var style = document.createElement('style');
  style.textContent = '.aw-sibling-loading .product-card__figure{opacity:.75;transition:opacity .15s}';
  document.head.appendChild(style);

  function swapImage(card, url) {
    var img = card.querySelector('.product-card__image--primary');
    if (!img || !url) return;
    img.removeAttribute('srcset');
    img.src = url;
    var secondary = card.querySelector('.product-card__image--secondary');
    if (secondary) secondary.remove();
  }

  function markSelected(container, swatch) {
    container.querySelectorAll('.color-swatch').forEach(function (el) {
      var selected = el === swatch;
      el.classList.toggle('is-selected', selected);
      if (selected) {
        el.setAttribute('aria-current', 'page');
      } else {
        el.removeAttribute('aria-current');
      }
    });
  }

  function updateLinks(card, url, title) {
    card.querySelectorAll('a.product-card__media, a.product-title').forEach(function (link) {
      link.setAttribute('href', url);
    });
    var titleEl = card.querySelector('.product-title');
    if (titleEl && title) titleEl.textContent = title;
  }

  function keepMissingSiblings(card, previousSwatches, handle) {
    var container = card.querySelector('.product-card__siblings');
    if (!container || !previousSwatches.length) return;

    var present = {};
    container.querySelectorAll('a[data-sibling-handle]').forEach(function (el) {
      present[el.getAttribute('data-sibling-handle')] = true;
    });

    previousSwatches.forEach(function (el) {
      var siblingHandle = el.getAttribute('data-sibling-handle');
      if (present[siblingHandle]) return;
      container.appendChild(el);
      present[siblingHandle] = true;
    });

    var current = container.querySelector('a[data-sibling-handle="' + handle + '"]');
    if (current) markSelected(container, current);
  }

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('.product-card__siblings a[data-sibling-handle]');
    if (!swatch) return;
    var card = swatch.closest('product-card');
    if (!card) return;

    event.preventDefault();
    if (swatch.classList.contains('is-selected')) return;

    var handle = swatch.getAttribute('data-sibling-handle');
    var url = swatch.getAttribute('href');

    swapImage(card, swatch.getAttribute('data-sibling-image'));
    markSelected(swatch.closest('.product-card__siblings'), swatch);
    updateLinks(card, url, swatch.getAttribute('data-sibling-title'));
    card.setAttribute('handle', handle);

    var requestId = (card.__awRequestId || 0) + 1;
    card.__awRequestId = requestId;
    card.classList.add('aw-sibling-loading');

    var fetchUrl = url.split('#')[0].split('?')[0] + '?section_id=' + SECTION_ID;

    fetch(fetchUrl, { credentials: 'same-origin' })
      .then(function (response) { return response.ok ? response.text() : Promise.reject(response.status); })
      .then(function (html) {
        if (card.__awRequestId !== requestId) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('product-card');
        if (!fresh) return;
        var previousSwatches = Array.prototype.map.call(
          card.querySelectorAll('.product-card__siblings a[data-sibling-handle]'),
          function (el) { return el.cloneNode(true); }
        );
        card.innerHTML = fresh.innerHTML;
        card.setAttribute('handle', fresh.getAttribute('handle') || handle);
        keepMissingSiblings(card, previousSwatches, handle);
      })
      .catch(function () {})
      .then(function () {
        if (card.__awRequestId === requestId) card.classList.remove('aw-sibling-loading');
      });
  });
})();
